<script lang="ts" setup>
import { defineAsyncComponent, type Component } from 'vue';
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const templates = import.meta.glob<Record<string, Component>>('./templates/*/index.vue', {
  eager: false,
  import: 'default',
});

const { data } = useAsyncData<Record<string, any>, Record<string, any>>(
  'home:index',
  () => $fetch('/template/v2/queryTemplateByCommunityId'),
  {
    default: () => ({}),
    transform: (data) => data.tempControl ?? {},
  },
);
</script>

<template>
  <main class="page-home">
    <Component
      :is="defineAsyncComponent(templates[`./templates/${data.type}/index.vue`])"
      :options="data.options"
      v-if="data?.type && templates[`./templates/${data.type}/index.vue`]"
    />
  </main>
</template>

<style lang="scss" scoped>
</style>
